<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p"></div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content u-no-pt">
			<div class="o-grid o-grid--wrap">
			    <div style="cursor: pointer;" class="c-content c-content--border-bottom c-content--border-top o-grid__cell o-grid__cell--w-100 u-no-pl" (click)="vm.openFileSelect(vm.documentId)">
			        <button type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md">
			            <i class="o-icon o-icon--file1 c-text c-text--main c-text--lg u-no-mr" aria-hidden="true"></i>
			            <span class="c-text c-text--gray" style="padding-left:15px;">{{ 'Chats.Other.Upload_Document' | translate }}</span>
			        </button>
			        <form>
			            <input id="{{ vm.documentId }}" class="u-hidden" name="file" type="file" accept=".pdf,.ddoc,.bdoc,.ddoc,.asice,.doc,.docx,.rft,.txt,.xls,.csv" (change)="onFileSelected($event, 'document')" [disabled]="vm.processing" />
			        </form>
			    </div>
			    <div style="cursor: pointer;" class="c-content c-content--border-bottom o-grid__cell o-grid__cell--w-100 u-no-pl" (click)="vm.openFileSelect(vm.imageId)">
			        <button type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md">
			            <i class="o-icon o-icon--image c-text c-text--main c-text--lg u-no-mr" aria-hidden="true"></i>
			            <span class="c-text c-text--gray" style="padding-left:10px;">{{ 'Chats.Other.Upload_Image' | translate }}</span>
			        </button>
			        <form>
			            <input id="{{ vm.imageId }}" class="u-hidden" name="file" type="file" accept="image/*" (change)="onFileSelected($event, 'picture')" [disabled]="vm.processing" />
			        </form>
			    </div>
			    <div style="cursor: pointer;" class="c-content c-content--border-bottom o-grid__cell o-grid__cell--w-100 u-no-pl" (click)="vm.openFileSelect(vm.videoId)">
			        <button type="button" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md">
			            <i class="o-icon o-icon--video-alt c-text c-text--main c-text--lg u-no-mr" aria-hidden="true"></i>
			            <span class="c-text c-text--gray" style="padding-left:10px;">{{ 'Chats.Other.Upload_Video' | translate }}</span>
			        </button>
			        <form>
			            <input id="{{ vm.videoId }}" class="u-hidden" name="file" type="file" accept="video/*" (change)="onFileSelected($event, 'video')" [disabled]="vm.processing" />
			        </form>
			    </div>
			</div>
		</div>
	</div>
</div>
